import { render, staticRenderFns } from "./SalesOrderComponent.vue?vue&type=template&id=5e9e422a&"
import script from "./SalesOrderComponent.vue?vue&type=script&lang=js&"
export * from "./SalesOrderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports